import { render } from "./OrderItemsTableTotals.vue?vue&type=template&id=534b6744"
import script from "./OrderItemsTableTotals.vue?vue&type=script&lang=js"
export * from "./OrderItemsTableTotals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__